import React from 'react';
import { View, SafeAreaView, StyleSheet, Platform } from 'react-native';
let crashlytics;
if (Platform.OS !== 'web') {
  // Firebase imports and initializations are only done for native platforms
  crashlytics = require('@react-native-firebase/crashlytics').default;
}
import Text from 'common/src/components/CommonCustomTxt';
import Icon from 'react-native-vector-icons/Feather';
import GlobalStyles from 'common/src/styles/GlobalStyles';
import CommonBtn from 'common/src/components/CommonBtn';
import RNRestart from 'react-native-restart';
import DeviceInfo, {useDeviceName} from 'react-native-device-info';
import { useTranslation } from 'react-i18next';
import {widthPercentageToDP as PR} from '../styles/PixelRatio';
import {ERROR_LOG_URL} from 'common/src/env.json';
import { errorRequest } from 'common/src/services/callService';

export class ErrorBoundary extends React.Component<any, any> {
  state = {
      error: false
  }

  static getDerivedStateFromError () {
    return { error: true };
  }

  componentDidCatch (error, errorInfo) {
    const route = this.props?.navigation?.current;
    const {
      user_id, 
      deviceName, 
      version,
    } = this.props

    let errorDetails = {
      user_id,
      appVersion: Platform.OS === 'web' ? version : DeviceInfo.getVersion(),
      buildNumber: Platform.OS === 'web' ? 'web build' : DeviceInfo.getBuildNumber(),
      deviceInfo: {
          systemName: Platform.OS === 'web' ? navigator.appName : DeviceInfo.getSystemName(),
          systemVersion: Platform.OS === 'web' ? navigator.appVersion : DeviceInfo.getSystemVersion(),
          deviceName: Platform.OS === 'web' ? navigator.platform : deviceName
      },
      error_screen: route,
      error_message:error.message,
      errorInfo
    }
    errorRequest(ERROR_LOG_URL,errorDetails)
  }

  handleRestart = async () => {
    Platform.OS === 'web' ? window.location.reload() : RNRestart.Restart();
  }

  render () {
    const t = this.props.t;
    if (this.state.error) {
      return (
        <SafeAreaView
          style={styles.container}
        >
            <View style={styles.content}>
              <View style={{ width: '100%', alignItems:'center', marginTop: PR(20)}}>
                <Icon
                  name='alert-circle'
                  size={PR(60)}
                  color={GlobalStyles.helpi.color}
                />
              </View>
              <Text style={{ fontSize: PR(32) }}>{t('translation:errors.error_boundary_title')}</Text>
              <View style={{marginBottom:PR(20)}}/>
              <Text renderAsHtml={true} style={{ marginVertical: PR(10), lineHeight: PR(23), fontWeight: '500', textAlign: 'justify' }}>
                {t('translation:errors.error_boundary_msg')}
              </Text>
              <View style={{marginBottom:PR(20)}}/>
              <CommonBtn testID={"restartBtn"} type={'primary'} title={t('translation:errors.error_boundary_btn')} click={() => {this.handleRestart()}}/>
            </View>
        </SafeAreaView>
      )
    } else {
      return this.props.children;
    }
  }
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: GlobalStyles.global.white,
    flex: 1,
  },
  content: {
    flex: 1,
    flexDirection: 'column',
    alignItems: 'center',
    alignSelf: 'center',
    width: '90%'
  }
});

export default function(props) {
  const { result } = useDeviceName();
  const { t } = useTranslation();
  if(Platform.OS !== 'web'){
    crashlytics().setUserId(props.navigation?.current?.user_id || "" );
    crashlytics().setAttributes({
      application_name: 'Amma',
      appVersion: DeviceInfo.getVersion(),
      buildNumber: DeviceInfo.getBuildNumber(),
      systemName: DeviceInfo.getSystemName(),
      systemVersion: DeviceInfo.getSystemVersion(),
      deviceName: result,
    });
  }

  return <ErrorBoundary {...props} deviceName={result} t={t} />;
}
